import React, { useEffect } from 'react'
interface InfoMenuProps {
    onClose: () => void;
    onDownload: () => void;
    onInfo: () => void;
    onDelete: () => void;
    onThumbnail?: (type: any) => void;
    showthumbnail?: boolean
    showLocationThumbnail?: boolean
}

const ImageInfoMenu: React.FC<InfoMenuProps> = ({ onClose, onDownload, onInfo, onDelete, showthumbnail, onThumbnail, showLocationThumbnail }) => {

    useEffect(() => {
        const handler = () => onClose();
        document.addEventListener('click', handler);
        return () => document.removeEventListener('click', handler);
    }, [onClose]);

    return (
        <div className="lg-info-menu" onClick={e => e.stopPropagation()}>
            <button className="lg-info-menu__item" onClick={onInfo}>
                <img src='/assets/images/view-meta.svg' />
                Info
            </button>
            <div className="lg-info-menu__divider" />
            <button className="lg-info-menu__item" onClick={onDelete}>
                <img src='/assets/images/Delete-icon-red.svg' />
                Delete
            </button>
            <div className="lg-info-menu__divider" />
            <button className="lg-info-menu__item" onClick={onDownload}>
                <img src='/assets/images/download-blue.svg' />
                Download image
            </button>

            {showthumbnail &&
                <>
                    <div className="lg-info-menu__divider" />
                    <button className="lg-info-menu__item" onClick={() => onThumbnail?.('image')}>
                        <img width={20} height={20} src='/assets/images/badge-check.svg' />
                        Use as thumbnail
                    </button>
                </>
            }
            {showLocationThumbnail &&
                <>
                    <div className="lg-info-menu__divider" />
                    <button
                        className="lg-info-menu__item"
                        onClick={() => onThumbnail?.('location')}
                    >
                        <img width={20} height={20} src='/assets/images/badge-check.svg' />
                        Use as location thumbnail
                    </button>
                </>
            }
        </div>
    );
};

export default ImageInfoMenu